import { createChunksMatcher } from '../createChunksMatcher';
import { createChunk } from '../Chunks';
export function withView(maybeResolvableView, child, exact) {
    return createChunksMatcher(maybeResolvableView, child, (function (view, request) { return view ? [createChunk('view', request, { view: view })] : []; }), exact, false, function (request) { return request.method !== 'HEAD'; });
}
//# sourceMappingURL=withView.js.map